import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Form, Col } from "reactstrap";

import "./style.css";
import historyAction from "../../redux/history/action";
import alertMessage from "../../redux/auth/action";
import PageHead from "../../component/pageHead/PageHead";
import CustomButton from "../../component/CustomButton/CustomButton";
import api from "../../config/api";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import { isNetworkRequestFailedError } from "../../config/helpers";

class EnrollmentCertificate extends Component {
  state = {
    pin: "",
    showLoader: false,
  };

  submit = async () => {
    const { alertBox, user } = this.props;
    const pin = user.User.rsaPin;

    this.setState({ showLoader: true });
    try {
      const response = await api.fetchEnrollmentCertificate(
        { pin },
        user.token
      );
      if (response.data.result)
        alertBox({
          type: "success",
          message: "Successfully sent to your registered email",
        });
      else {
        throw new Error(response.data.Message);
      }
    } catch (e) {
      alertBox({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.submit : null,
      });
    }
    this.setState({ showLoader: false });
  };

  render() {
    const { showLoader } = this.state;

    return (
      <div>
        <PageHead
          containerStyles={{ width: "100%" }}
          title="ENROLLMENT CERTIFICATE"
        />
        <Form className="my-2">
          <Row className="flex1">
            {/* <Col lg={9} md={9} sm={6} className="p-0">
              <InputComp
                name="micro-pin"
                placeholder="PIN"
                containerStyles={{ width: "100%" }}
                inputContainerClasses={"mt-0 mx-0"}
                value={pin}
                onChange={e => {
                  this.setState({ pin: e.target.value });
                }}
              />
            </Col> */}
            <Col lg={3} md={3} sm={6} className="mx-auto pl-0 pl-sm-3 pr-0">
              <CustomButton
                buttonText="Check"
                buttonContainerClasses={"margin-y"}
                buttonStyle={{ width: "100%" }}
                onClick={() => {
                  this.submit();
                }}
              />
            </Col>
          </Row>
        </Form>
        {showLoader && <CustomLoader loadingText={"Loading..."} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  alertBox: alertMessage.setAlertMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EnrollmentCertificate);
